import React from 'react';
import useByteHooks from './byte-hook';
import { useNoAuthHooks } from '../../../../../../Hooks/hooks';
import { ICompanyResponse } from '../../../../../../Interfaces/responseTypes';
import { VisitorPageContents } from '../../../visitorPage';
import CustomDialog from '../../../../../../Components/Dialog/customDialog';
import styles from './byte.module.scss';

interface IByteProps {
  type: VisitorPageContents,
  data: ICompanyResponse,
}

const MrByte: React.FC<IByteProps> = (props) => {
  const { data } = props;
  const { open, onCloseDialog, dialogComponent, contentType, renderFooter, renderPage } = useByteHooks(props.data, props.type);
  const { mobileScreen } = useNoAuthHooks();
  
  return (
    <div className={styles.page}>
      {renderPage(contentType)}
      {
        data.business_profile && mobileScreen
        &&
        renderFooter()
      }
      <CustomDialog
        open={open}
        onClose={onCloseDialog}
        children={dialogComponent}
      />
    </div>
  )
};

export default MrByte
